import { render } from "./ResponsiveDialog.vue?vue&type=template&id=04869cdc&scoped=true"
import script from "./ResponsiveDialog.vue?vue&type=script&lang=js"
export * from "./ResponsiveDialog.vue?vue&type=script&lang=js"

import "./ResponsiveDialog.vue?vue&type=style&index=0&id=04869cdc&scoped=true&lang=css"
import "./ResponsiveDialog.vue?vue&type=style&index=1&id=04869cdc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04869cdc"]])

export default __exports__